import { motion } from 'framer-motion';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

const Button = ({
    children,
    variant = 'primary',
    size = 'md',
    className = '',
    onClick,
    href,
    download,
    target,
    rel,
    disabled = false,
    type = 'button',
    ...props
}) => {
    const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-accent-blue focus:ring-offset-2 focus:ring-offset-bg-primary disabled:opacity-50 disabled:cursor-not-allowed';

    const variants = {
        primary: 'bg-gradient-to-r from-accent-blue to-accent-blue-deep text-white hover:shadow-glow-blue rounded-[12px]',
        secondary: 'bg-transparent border border-white/20 text-white hover:border-accent-blue hover:shadow-glow-blue rounded-[12px]',
        ghost: 'bg-transparent text-text-secondary hover:text-accent-blue hover:bg-white/5 rounded-[12px]',
    };

    const sizes = {
        sm: 'px-4 py-2 text-sm',
        md: 'px-6 py-3 text-base',
        lg: 'px-8 py-4 text-lg',
    };

    const classes = twMerge(clsx(baseStyles, variants[variant], sizes[size], className));

    const motionProps = {
        whileHover: { scale: disabled ? 1 : 1.02 },
        whileTap: { scale: disabled ? 1 : 0.98 },
        transition: { duration: 0.2 },
    };

    if (href) {
        return (
            <motion.a
                href={href}
                download={download}
                target={target}
                rel={rel}
                className={classes}
                {...motionProps}
                {...props}
            >
                {children}
            </motion.a>
        );
    }

    return (
        <motion.button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={classes}
            {...motionProps}
            {...props}
        >
            {children}
        </motion.button>
    );
};

export default Button;
